import PureImage from '../Image/PureImage';
import { SCALE } from '../Image/ImageScale';
import { classes, getHeadingClass } from '../../../lib/utils/cssUtils';
import PureHeading, { PureHeadingProps } from '../Heading/PureHeading';
import styles from './HeadingWithIcon.module.scss';

export type HeadingWithIconProps = Omit<PureHeadingProps, 'className'> & {
  icon?: string;
  variants?: string[];
  classNames?: Partial<Record<'container' | 'heading' | 'icon', string>>;
};

const HeadingWithIcon = ({ icon, classNames, variants = [], as, ...rest }: HeadingWithIconProps) => {
  const headingClass = getHeadingClass(variants);
  const iconClasses = classes(styles[as ?? headingClass ?? rest.level], classNames?.icon);

  if (!rest.children && !icon) {
    return null;
  }

  return (
    <div className={classes(styles.container, classNames?.container)}>
      {!!icon && <PureImage src={icon} scale={SCALE.ICON} className={iconClasses} />}
      <PureHeading
        {...rest}
        as={as ?? headingClass}
        className={classes(styles.heading, classNames?.heading, headingClass)}
      />
    </div>
  );
};

export default HeadingWithIcon;
